import { supabase } from '../lib/supabase';

export const consultationService = {
  async createConsultation(consultationData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    
    const { data, error } = await supabase?.from('consultations')?.insert({
        client_id: user?.id || null,
        title: consultationData?.title,
        description: consultationData?.description,
        scheduled_date: consultationData?.scheduledDate || null,
        duration_minutes: consultationData?.durationMinutes || 60,
        status: 'scheduled'
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  async getUserConsultations(userId) {
    const { data, error } = await supabase?.from('consultations')?.select('*')?.eq('client_id', userId)?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  async updateConsultation(consultationId, updates) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('consultations')?.update(updates)?.eq('id', consultationId)?.eq('client_id', user?.id)?.select()?.single();

    if (error) throw error;
    return data;
  }
};